import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import TableBox from './tableBox';
import TabTitle from '../../../../components/tabTitle';
import Iframe from './iframeWrapper';

class RankTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        current: this.props.content.current,
    };

    handleMouseOver = index => {
        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { title, tabTits, tableTits, url, data } = this.props.content;
        const { current } = this.state;
        // const data = {};
        const renderItem = () => {
            let Dom = null;

            switch (current) {
                case 'ah':
                    Dom = <Iframe src={'https://ifeng.szfiu.com/dynamic.html#/ah'} />;
                    break;
                case 'ggth':
                    Dom = <Iframe src={'https://ifeng.szfiu.com/dynamic.html#/stock-connect-rank-sh'} />;
                    break;
                case 'ggts':
                    Dom = <Iframe src={'https://ifeng.szfiu.com/dynamic.html#/stock-connect-rank-sz'} />;
                    break;

                default:
                    Dom = (
                        <TableBox
                            content={{
                                tit: tableTits,
                                data: data && data[current],
                                url: url[current],
                            }}
                            isOpen={this.props.isOpen}
                        />
                    );
                    break;
            }

            return Dom;
        };

        return (
            <div className={styles.tab}>
                <TabTitle title={title} tabTits={tabTits} current={current} callback={this.handleMouseOver} />
                {renderItem()}
                {/* <TableBox
                    content={{
                        tit: tableTits,
                        data: data[current],
                        url: url[current],
                    }}
                /> */}
            </div>
        );
    }
}

export default errorBoundary(RankTable);
